import { useInfiniteQuery } from '@tanstack/react-query';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { useUserStore } from 'src/store/user-store';
import { ApiError } from 'src/types/interfaces/api-error';
import { MeiliSearchResponse } from 'src/types/responses/meilisearch';
import { fetchEmployeesGroups } from '../lib/employees-groups';
import { employeesGroupsKeys } from '../query-keys/employees-groups';
import { EmployeeGroupResponse } from '../types/response/employee-group.response';

export const useInfiniteEmployeesGroups = (
  perPage: number,
  enabled: boolean = true,
) => {
  const { directoryToken } = useUserStore();

  const searchState: SearchState = {
    filter: [],
    q: '',
    sort: [],
  };

  return useInfiniteQuery<MeiliSearchResponse<EmployeeGroupResponse>, ApiError>(
    {
      queryKey: employeesGroupsKeys.infiniteList(perPage),
      queryFn: ({ pageParam }) =>
        fetchEmployeesGroups(
          directoryToken!,
          searchState,
          Number(pageParam),
          perPage,
        ),
      initialPageParam: 1,
      getNextPageParam: (lastPage, allPages) => {
        const nextPage =
          lastPage.hits.length === lastPage.limit
            ? allPages.length + 1
            : undefined;

        if (nextPage === undefined) {
          return undefined;
        }

        const alreadyFetchedAllItems =
          allPages.length * lastPage.limit === lastPage.estimatedTotalHits;

        if (alreadyFetchedAllItems) {
          return undefined;
        }

        return nextPage;
      },
      enabled,
    },
  );
};
